<div [ngStyle]="style"></div>
